import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {calculatePercent} from "./percents_handling_helpers";

/**
 * minimum number of offers behind a monthly aggregate for the median to be shown at all.
 *
 * TODO(RP-795): the real threshold has to be agreed with the analytics team (M. Bieniek / T. Radziewicz) -
 * the ticket only says "small cities are the likely source of odd values". 30 is a placeholder that keeps
 * every city we publish today well inside the safe range (June 2026: Olsztyn 697 ... Warszawa 17 132 offers),
 * so it only ever fires on genuinely thin data.
 */
export const MEDIAN_PRICE_M2_MIN_AVAILABLE_OFFERS = 30;

export const getMedianPriceM2 = (report?: IPriceReportAveragePrices | null): number | null => {
    if (!report) {
        return null;
    }

    // BigData has no pg type parser, so a column created as `numeric` instead of `double precision` would
    // arrive as a string ("11552.00"). Coerce rather than trust the declared type.
    const median = Number(report.median_price_m2);

    if (!Number.isFinite(median) || median <= 0) {
        return null;
    }

    if (!report.available_offers || report.available_offers < MEDIAN_PRICE_M2_MIN_AVAILABLE_OFFERS) {
        return null;
    }

    return median;
};

/**
 * The median is always presented together with its year-to-year direction, so a median without a year-ago
 * counterpart is not renderable - every surface hides the whole median statement in that case.
 */
export const getMedianPriceM2WithYearToYearPercent = (
    actualReport?: IPriceReportAveragePrices | null,
    yearAgoReport?: IPriceReportAveragePrices | null
): {price: number; percent: number} | null => {
    const price = getMedianPriceM2(actualReport);
    const yearAgoPrice = getMedianPriceM2(yearAgoReport);

    if (!price || !yearAgoPrice) {
        return null;
    }

    return {price, percent: calculatePercent(yearAgoPrice, price)};
};
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {calculatePercent} from "./percents_handling_helpers";

/**
 * minimum number of offers behind a monthly aggregate for the median to be shown at all.
 *
 * TODO(RP-795): the real threshold has to be agreed with the analytics team (M. Bieniek / T. Radziewicz) -
 * the ticket only says "small cities are the likely source of odd values". 30 is a placeholder that keeps
 * every city we publish today well inside the safe range (June 2026: Olsztyn 697 ... Warszawa 17 132 offers),
 * so it only ever fires on genuinely thin data.
 */
export const MEDIAN_PRICE_M2_MIN_AVAILABLE_OFFERS = 30;

export const getMedianPriceM2 = (report?: IPriceReportAveragePrices | null): number | null => {
    if (!report) {
        return null;
    }

    // BigData has no pg type parser, so a column created as `numeric` instead of `double precision` would
    // arrive as a string ("11552.00"). Coerce rather than trust the declared type.
    const median = Number(report.median_price_m2);

    if (!Number.isFinite(median) || median <= 0) {
        return null;
    }

    if (!report.available_offers || report.available_offers < MEDIAN_PRICE_M2_MIN_AVAILABLE_OFFERS) {
        return null;
    }

    return median;
};

/**
 * The median is always presented together with its year-to-year direction, so a median without a year-ago
 * counterpart is not renderable - every surface hides the whole median statement in that case.
 */
export const getMedianPriceM2WithYearToYearPercent = (
    actualReport?: IPriceReportAveragePrices | null,
    yearAgoReport?: IPriceReportAveragePrices | null
): {price: number; percent: number} | null => {
    const price = getMedianPriceM2(actualReport);
    const yearAgoPrice = getMedianPriceM2(yearAgoReport);

    if (!price || !yearAgoPrice) {
        return null;
    }

    return {price, percent: calculatePercent(yearAgoPrice, price)};
};
